import {
  Component,
  OnInit,
  ElementRef,
  Input,
  ViewEncapsulation,
  Output,
  EventEmitter,
} from '@angular/core';
import { HangfireRecurringJobService } from '../../services/hangfire-recurring-job.service';
import { CreateHangfireRecurringJobDTO } from '../../interfaces/hangfire-recurring-job';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  ValidationErrors,
} from '@angular/forms';
import { Validators } from '@angular/forms';
import { SelectItem } from 'primeng';
import cron from 'cron-validate';

export interface CreateForm {
  cronSchedule: FormControl<string>;
  description: FormControl<string>;
  methodName: FormControl<string>;
  queueName: FormControl<string>;
}

export function cronExpressionValidator(control: AbstractControl): ValidationErrors | null {
  const cronResult = cron(control.value);
  return cronResult.isValid() ? null : { invalidCronExpression: { message: cronResult.error[0] } };
}

@Component({
  selector: 'hangfire-job-dialog',
  templateUrl: './hangfire-job-dialog.component.html',
  providers: [],
})
export class HangfireJobDialogComponent implements OnInit {
  public formGroup: FormGroup<CreateForm>;

  @Input() visible: boolean = false;

  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Output() formSubmitted: EventEmitter<CreateHangfireRecurringJobDTO> =
    new EventEmitter<CreateHangfireRecurringJobDTO>();

  public availableMethods: SelectItem[];

  constructor(private hangfireService: HangfireRecurringJobService, private fb: FormBuilder) {
    this.formGroup = this.fb.group<CreateForm>({
      cronSchedule: new FormControl('', [cronExpressionValidator]),
      description: new FormControl('', [Validators.required]),
      methodName: new FormControl('', [Validators.required]),
      queueName: new FormControl(null),
    });
  }

  ngOnInit(): void {}

  async onShow(): Promise<void> {
    this.formGroup.reset({
      methodName: '',
      description: '',
      cronSchedule: '',
      queueName: null,
    });
    this.formGroup.markAsUntouched();
    await this.getAvailableMethods();
    this.formGroup.controls.methodName.patchValue(this.availableMethods[0].value);
  }

  async getAvailableMethods(): Promise<void> {
    this.availableMethods = (await this.hangfireService.getAvailableMethods()).map((x) => ({
      label: x,
      value: x,
    }));
  }

  onSubmit() {
    if (this.formGroup.invalid) {
      return;
    }

    this.formSubmitted.emit(this.formGroup.getRawValue() as CreateHangfireRecurringJobDTO);
  }
}
